<nav class="navbar navbar-default">
  <div class="container-fluid">
    <div class="navbar-header">

      <a routerLink="/" class="navbar-brand">
        Event App</a>
    </div>

    <div class="navbar-collapse">
      <ul class="nav navbar-nav">
        <li routerLinkActive="active" *ngIf="(authState | async).authenticated" (click)="onFetchData()"><a routerLink="/events">Events</a></li>
        <!-- Removed Question Component  <li routerLinkActive="active" *ngIf="false"><a routerLink="/question-list">Question List</a></li> -->
        <li routerLinkActive="active"><a routerLink="/tutorial">Tutorial</a></li>
        <li routerLinkActive="active"><a routerLink="/report">Reports</a></li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <ng-template [ngIf]="!(authState | async).authenticated">
         <!-- Removed Register Link <li><a routerLink="/signup">Register</a></li> -->
          <li><a routerLink="/signin">Login</a></li>
        </ng-template>

        <li><a
          style="cursor: pointer;"
          (click)="onLogout()"
          *ngIf="(authState | async).authenticated">Logout</a></li>
      </ul>
          <!-- DropDown which was removed
        <li class="dropdown" appDropdown *ngIf="(authState | async).authenticated">
          <a style="cursor: pointer;" class="dropdown-toggle" role="button">Manage <span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li><a style="cursor: pointer;" (click)="onSaveData()">Save Data</a></li>
            <li><a style="cursor: pointer;" (click)="onFetchData()">Fetch Data</a></li>
          </ul>
        </li>
          -->
    </div>
  </div>
</nav>



// WEBPACK FOOTER //
// ./src/app/core/header/header.component.html